import { createFileRoute, useRouter } from '@tanstack/react-router';
import { Screen } from '@/components/chrome';

export const Route = createFileRoute('/_authed/about')({
  component: AboutPage,
});

// The Razorpay policy hub that used to live here has moved off this app. This is
// now an internal booking tool, not the public merchant site — the crawlable
// policy pages (terms/privacy/refunds/return/pricing/service-delivery/contact) are
// served from the public site that the Razorpay merchant URL points at.

function AboutPage() {
  const router = useRouter();
  const back = () => {
    if (router.history.canGoBack()) router.history.back();
    else void router.navigate({ to: '/' });
  };

  return (
    <Screen title="About" onBack={back}>
      <div
        className="wb-col wb-gap-12"
        style={{ alignItems: 'center', textAlign: 'center', margin: '6px 0 26px' }}
      >
        <img src="/weebee-bee.png" alt="" style={{ width: 56, height: 56 }} />
        <div>
          <div className="wb-h2" style={{ fontFamily: 'var(--font-display)' }}>
            WayQ Tickets
          </div>
          <p className="wb-small" style={{ marginTop: 6, maxWidth: 360 }}>
            Metro, bus, rides &amp; entry passes on the ONDC network.
          </p>
        </div>
      </div>

      <div className="wb-tiny" style={{ textAlign: 'center', marginTop: 26, lineHeight: 1.6 }}>
        © 2026 WayQ Technologies Private Limited
        <br />
        <abbr title="Goods and Services Tax Identification Number">GSTIN</abbr> 32AAECW2541H1ZL
      </div>
    </Screen>
  );
}
